import React from 'react'
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import tw from "twin.macro";
import "../style.css"
import { css } from "styled-components/macro"; //eslint-disable-line
 let uni = 'https://upload.wikimedia.org/wikipedia/tr/9/92/Istanbul_Universitesi.png'
function ISTANBUL() {
    const Subheading = tw.span`tracking-wider text-sm font-medium`;
    const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
    const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
    const Description = tw.span`inline-block mt-8`;
    const imageCss = tw`rounded-4xl`;
    const Container = tw.div`relative`;
    const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
    const Heading = tw.h1`font-black text-black text-3xl md:text-5xl  max-w-3xl`;


  return (
    <AnimationRevealPage>
         <Hero
        heading={<><HighlightedText>Istanbul University</HighlightedText></>}
        description="Founded in 1453 by Sultan Mehmed II (Mehmed the Conqueror) after the conquest of Constantinople, Istanbul University is the oldest and one of the most prestigious universities in Turkey. Originally established as a madrasah (Islamic school), it evolved into a modern university in 1933 during Turkey’s higher education reform."
        imageSrc={uni}
        imageCss={imageCss}
        imageDecoratorBlob={true}
    
      />
           <Container>
      <TwoColumn>
<Heading>Students</Heading>
</TwoColumn>
</Container>
      <Container>
      <TwoColumn>
    



     
      <div className="table-container">
    <table>
        <thead>
            <tr>
                <th>Name</th>
                <th>Department</th>
                <th>University Entrance Year</th>
                <th>FIRST Team Number - Name</th>
                <th>FIRST Programs Participated</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td> Yigit Efe Yasar</td>
                <td>   Business  </td>
                <td>  2023</td>
                <td> 7458 , 8159 </td>
                <td>FRC, FLL, FLL Jr.</td>
            </tr>
          
        
        </tbody>
    </table>
</div>


</TwoColumn>
</Container>
<Footer />
        </ AnimationRevealPage>
  )
}

export default ISTANBUL